/* eslint-disable no-param-reassign */ // Desliga a retribuição de valor a uma variável

// Função vai deixar a primeira letra de uma string em maiúscula
export const Capitalize = (text: string) => {
  if (!text) return '';
  text = text.toLowerCase();
  if (text.includes(' ')) {
    const words = text.split(' ');
    const capitalizedWords = words.map(word => {
      if (word.length > 1) {
        return word[0].toUpperCase() + word.slice(1);
      }
      return word;
    });
    return capitalizedWords.join(' ');
  }
  return text[0].toUpperCase() + text.slice(1);
};
